module.exports = __webpack_public_path__ + "static/media/upload.f69c0202.svg";